var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 25,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 6.24475H37.3334V42.7552H13.3334V6.24475Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4532 8.22388C33.125 8.22388 32.8594 7.95825 32.8594 7.63013C32.8594 7.30721 33.125 7.04159 33.4532 7.04159C33.7813 7.04159 34.0417 7.30721 34.0417 7.63013C34.0417 7.95825 33.7813 8.22388 33.4532 8.22388ZM33.974 35.0155C33.974 35.901 33.2448 36.6249 32.3594 36.6249H17.2969C16.4115 36.6249 15.6823 35.901 15.6823 35.0155V10.7135C15.6823 9.82804 16.4115 9.09888 17.2969 9.09888H32.3594C33.2448 9.09888 33.974 9.82804 33.974 10.7135V35.0155ZM32.8907 39.1145C32.8907 39.4166 32.6407 39.6666 32.3386 39.6666H30.1875C29.8855 39.6666 29.6355 39.4166 29.6355 39.1145V38.953C29.6355 38.6458 29.8855 38.3958 30.1875 38.3958H32.3386C32.6407 38.3958 32.8907 38.6458 32.8907 38.953V39.1145ZM24.8282 41.6301C23.8282 41.6301 23.0209 40.8228 23.0209 39.8228C23.0209 38.8228 23.8282 38.0103 24.8282 38.0103C25.8282 38.0103 26.6407 38.8228 26.6407 39.8228C26.6407 40.8228 25.8282 41.6301 24.8282 41.6301ZM20.0209 39.1145C20.0209 39.4166 19.7709 39.6666 19.4688 39.6666H17.3177C17.0157 39.6666 16.7657 39.4166 16.7657 39.1145V38.953C16.7657 38.6458 17.0157 38.3958 17.3177 38.3958H19.4688C19.7709 38.3958 20.0209 38.6458 20.0209 38.953V39.1145ZM22.9896 7.30721H26.6667V7.95304H22.9896V7.30721ZM34.2552 6.27075H15.4063C14.3438 6.27075 13.474 7.14054 13.474 8.20304V41.1405C13.474 42.203 14.3438 43.0728 15.4063 43.0728H34.2552C35.3177 43.0728 36.1875 42.203 36.1875 41.1405V8.20304C36.1875 7.14054 35.3177 6.27075 34.2552 6.27075Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85415 29.4843C9.67706 29.4843 9.50519 29.4323 9.35415 29.3229C9.23436 29.2396 6.47394 27.1458 6.74998 21.0729C6.97915 15.9843 9.47915 14.0729 9.58332 13.9948C9.96352 13.7187 10.4896 13.7968 10.7708 14.1718C11.0469 14.5468 10.9687 15.0729 10.5989 15.3489C10.5052 15.4218 8.63019 16.9427 8.44269 21.1458C8.20832 26.2396 10.3333 27.9427 10.3541 27.9583C10.7291 28.2343 10.8125 28.7604 10.5364 29.1406C10.3698 29.3646 10.1146 29.4843 9.85415 29.4843Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 7,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74475 9.33337H7.99996V33.3334H1.74475V9.33337Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 33.0208C6.8489 33.0208 6.69786 32.9792 6.56244 32.8958C6.36452 32.776 1.74473 29.8594 1.99994 21.1302C2.26556 12.026 6.52598 10.099 6.70827 10.0208C7.13536 9.83855 7.63536 10.0365 7.81765 10.4688C7.99994 10.8906 7.80202 11.3854 7.38015 11.5729C7.30202 11.6146 3.92181 13.3229 3.69265 21.1771C3.46869 28.8594 7.2864 31.3542 7.44786 31.4531C7.83848 31.7031 7.96348 32.224 7.71869 32.6198C7.55723 32.875 7.28119 33.0208 6.99994 33.0208Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4792 29.4843C39.2188 29.4843 38.9635 29.3646 38.7969 29.1406C38.5208 28.7656 38.599 28.2343 38.9792 27.9583C38.9896 27.9479 41.1198 26.2343 40.8906 21.1458C40.6979 16.9218 38.7604 15.3698 38.7396 15.3541C38.3646 15.0781 38.2865 14.5468 38.5625 14.1718C38.8385 13.7968 39.3698 13.7187 39.7448 13.9948C39.8542 14.0729 42.3542 15.9843 42.5833 21.0729C42.8542 27.1458 40.099 29.2396 39.9792 29.3229C39.8281 29.4323 39.651 29.4843 39.4792 29.4843Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 9,
    width: 7,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 9.33337H47.1407V33.3334H41.3334V9.33337Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3334 33.0209C42.0469 33.0209 41.7657 32.875 41.6094 32.6146C41.3647 32.2136 41.4897 31.6928 41.8907 31.4532C42.0469 31.3542 45.8647 28.8594 45.6407 21.1771C45.4063 13.2657 41.9844 11.5886 41.948 11.573C41.5313 11.3803 41.3386 10.8803 41.5261 10.4584C41.7136 10.0365 42.2032 9.83859 42.6251 10.0209C42.8074 10.099 47.0626 12.0261 47.3334 21.1303C47.5886 29.8594 42.9688 32.7761 42.7709 32.8959C42.6355 32.9792 42.4844 33.0209 42.3334 33.0209Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.e6f8abdc81326771bee6120ab24f4cb9.svg";
export { ForwardRef as ReactComponent };